import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">About Pixel Perfect.</h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-xl text-gray-600 mb-6">
            Pixel Perfect is a premier fashion photography studio specializing in capturing the essence of style, 
            beauty, and elegance. Our passion lies in creating stunning visual narratives that showcase fashion 
            in its most captivating form, from haute couture to street style.
          </p>
          <p className="text-xl text-gray-600">
            Located at Compass House, Portway, Penarth Marina, CF64 1TT, we combine artistic vision with 
            technical excellence to deliver photography that transcends the ordinary and creates lasting impressions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Services</h4>
            <ul className="space-y-3 text-gray-600">
              <li>Fashion Photography <span className="block text-sm text-gray-500">Editorial & Commercial</span></li>
              <li>Portrait Sessions <span className="block text-sm text-gray-500">Individual & Group</span></li>
              <li>Brand Campaigns <span className="block text-sm text-gray-500">Creative Direction</span></li>
              <li>Event Photography <span className="block text-sm text-gray-500">Fashion Shows & Launches</span></li>
              <li>Product Photography <span className="block text-sm text-gray-500">Accessories & Apparel</span></li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Recognition</h4>
            <ul className="space-y-3 text-gray-600">
              <li>
                <a href="#0" className="hover:text-gray-900">
                  Fashion Photographer of the Year
                  <span className="block text-sm text-gray-500">British Photography Awards — 2023</span>
                </a>
              </li>
              <li>
                <a href="#0" className="hover:text-gray-900">
                  Best Editorial Series
                  <span className="block text-sm text-gray-500">Vogue Photography Prize — 2023</span>
                </a>
              </li>
              <li>
                <a href="#0" className="hover:text-gray-900">
                  Creative Excellence Award
                  <span className="block text-sm text-gray-500">Fashion Photography Society — 2022</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Expertise</h4>
            <ul className="space-y-3 text-gray-600">
              <li>Fashion Photography</li>
              <li>Creative Direction</li>
              <li>Studio Lighting</li>
              <li>Post-Production</li>
              <li>Brand Storytelling</li>
              <li>Visual Composition</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;